import { createBrowserRouter } from 'react-router-dom';

import MainLayout from 'layout/MainLayout';
import HomePage from 'pages/Home';
import FaqPage from 'pages/Faq';
import SearchPage from 'pages/Search';

import ArticleDetailPage from 'pages/ArticleDetail';
import CategoryDetailPage from 'pages/CategoryDetail';
import PartnerPortalPage from 'pages/PartnerPortal';
import Contact from 'pages/Contact';
import NotFoundPage from 'pages/NotFound';

export const router = createBrowserRouter([
  {
    path: '/',
    element: <MainLayout />,
    children: [
      { index: true, element: <HomePage /> },
      { path: '/faq', element: <FaqPage /> },
      { path: '/search', element: <SearchPage /> },

      { path: '/partner', element: <PartnerPortalPage /> },
      { path: '/contact', element: <Contact /> },
      { path: '/faq/article/:id', element: <ArticleDetailPage /> },
      { path: '/faq/category/:categoryId', element: <CategoryDetailPage /> },
      { path: '/faq/folder/:folderId', element: <CategoryDetailPage /> },
      // Yeni URL yapısı
      { path: '/en/support/solutions/folders/:folderId', element: <CategoryDetailPage /> },
      { path: '/tr/support/solutions/folders/:folderId', element: <CategoryDetailPage /> },
      { path: '/ru-RU/support/solutions/folders/:folderId', element: <CategoryDetailPage /> },
      { path: '/en/support/solutions/articles/:id', element: <ArticleDetailPage /> },
      { path: '/tr/support/solutions/articles/:id', element: <ArticleDetailPage /> },
      { path: '/ru-RU/support/solutions/articles/:id', element: <ArticleDetailPage /> },
      // SEO dostu URL yapısı
      { path: '/en/support/solutions/articles/:id-:slug', element: <ArticleDetailPage /> },
      { path: '/tr/support/solutions/articles/:id-:slug', element: <ArticleDetailPage /> },
      { path: '/ru-RU/support/solutions/articles/:id-:slug', element: <ArticleDetailPage /> },
      { path: '*', element: <NotFoundPage /> },
    ],
  },
]);
